import * as React from 'react';

import {
  IconCar16,
  IconWalk16,
  IconMetroMsk16,
  IconMetroSam16,
  IconMetroNN16,
  IconMetroKzn16,
  IconMetroNovosib16,
  IconMetroEkb16,
  IconMetroSpb16,
} from '@cian/ui-kit';
import { IIconProps } from '@cian/ui-kit/icons/internal';

import { ETransportType, EUndergroundType } from '../../types/subway';

export const transportIconMap: Record<ETransportType, React.FC> = {
  [ETransportType.Walk]: IconWalk16,
  [ETransportType.Transport]: IconCar16,
};

export const metroIconMap: Record<EUndergroundType, React.FunctionComponent<IIconProps>> & {
  default: React.FunctionComponent<IIconProps>;
} = {
  [EUndergroundType.Spb]: IconMetroSpb16,
  [EUndergroundType.Mow]: IconMetroMsk16,
  [EUndergroundType.Ekb]: IconMetroEkb16,
  [EUndergroundType.Kzn]: IconMetroKzn16,
  [EUndergroundType.Nsk]: IconMetroNovosib16,
  [EUndergroundType.Nn]: IconMetroNN16,
  [EUndergroundType.Smr]: IconMetroSam16,
  default: IconMetroMsk16,
};
